import React from 'react';
import classNames from 'classnames';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';

const getIconName = item => item.iconName || 'ico_linkarrow';

const MenuItem = ({
  item,
  isEmphasised
}) => React.createElement("li", {
  role: "none",
  className: classNames('page-menu__item', {
    'page-menu__item--logged-in': isEmphasised
  })
}, React.createElement("a", {
  role: "menuitem",
  tabIndex: "0",
  className: "page-menu__item-link",
  href: item.url
}, React.createElement("span", {
  className: "page-menu__item-text"
}, item.text), item.notification && React.createElement("span", {
  className: "page-menu__item-notification"
}, item.notification), React.createElement(SvgIcon, {
  className: classNames('page-menu__item-icon', {
    'page-menu__item-icon--small': !isEmphasised
  }),
  iconName: getIconName(item),
  color: "black"
})));

export default MenuItem;